import { render, staticRenderFns } from "./PaginationFilter.vue?vue&type=template&id=4686e584&scoped=true"
import script from "./PaginationFilter.vue?vue&type=script&lang=js"
export * from "./PaginationFilter.vue?vue&type=script&lang=js"
import style0 from "./PaginationFilter.vue?vue&type=style&index=0&id=4686e584&prod&lang=scss&scoped=true"
import style1 from "./PaginationFilter.vue?vue&type=style&index=1&id=4686e584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4686e584",
  null
  
)

export default component.exports